module.exports = __webpack_public_path__ + "static/tortle-f8ad0ec57d601fe9bcfa0a4e75cd5c27.png";